/**
 * Utility.
 */

export function anyOf (target, candidates) {
    return candidates.filter(c => c === target).length > 0
}

/**
 * Dispatch a custom event to `window` object.
 */
export function dispatchWindowEvent (eventName, data) {
    var event = document.createEvent('CustomEvent')
    event.initCustomEvent(eventName, true, true, data)
    window.dispatchEvent(event)
}



//////////////////
// WEBPACK FOOTER
// ./src/shared/util.js
// module id = 2
// module chunks = 0 1